export const loadScreenOverlay = (artifactId, imageData, metadata, deps) => {
    const { artifactActions, addStatus } = deps;
    try {
        const imageBlob = new Blob([imageData], { type: 'image/png' });
        const blobUrl = URL.createObjectURL(imageBlob);
        const overlayData = {
            id: artifactId,
            imageUrl: blobUrl,
            metadata: metadata,
            position: { x: 20, y: 20 }
        };
        artifactActions.addScreenOverlay(overlayData);
        artifactActions.updateLoaded(artifactId, {
            type: 'screen',
            cesiumObject: overlayData,
            metadata: metadata,
            blobUrl: blobUrl
        });
        artifactActions.resetRetryCount(artifactId);
        artifactActions.updateVisibility(artifactId, true);
        artifactActions.setLoading(artifactId, false);
    }
    catch (error) {
        artifactActions.setLoading(artifactId, false);
        addStatus(`Error creating screen overlay: ${error}`);
    }
};
export const loadScreenOverlayFromUrl = (artifactId, url, metadata, deps) => {
    const { artifactActions, addStatus } = deps;
    try {
        const overlayData = {
            id: artifactId,
            imageUrl: url,
            metadata: metadata,
            position: { x: 20, y: 20 }
        };
        artifactActions.addScreenOverlay(overlayData);
        artifactActions.updateLoaded(artifactId, {
            type: 'screen',
            cesiumObject: overlayData,
            metadata: metadata
        });
        artifactActions.resetRetryCount(artifactId);
        artifactActions.updateVisibility(artifactId, true);
        artifactActions.setLoading(artifactId, false);
    }
    catch (error) {
        artifactActions.setLoading(artifactId, false);
        addStatus(`Error creating screen overlay from URL: ${error}`);
    }
};
